var _path, _ellipse, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconWarning = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 65,
  height: 65,
  viewBox: "0 0 65 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.5 65C50.4493 65 65 50.4493 65 32.5C65 14.5507 50.4493 0 32.5 0C14.5507 0 0 14.5507 0 32.5C0 50.4493 14.5507 65 32.5 65Z",
  fill: "#BCD9C9"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 30.5,
  cy: 32,
  rx: 18.5,
  ry: 20,
  fill: "white"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 20.25,
  stroke: "#727D79",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 23.0957L39.9002 36.7454H24.0997L32 23.0957ZM22.2847 35.6962C21.4769 37.0916 22.4841 38.8437 24.0998 38.8437H39.9002C41.5159 38.8437 42.5231 37.0916 41.7153 35.6962L33.8151 22.0465C33.0072 20.6512 30.9928 20.6512 30.1849 22.0465L22.2847 35.6962ZM30.9508 28.352V31.4995C30.9508 32.0766 31.423 32.5487 32 32.5487C32.577 32.5487 33.0492 32.0766 33.0492 31.4995V28.352C33.0492 27.775 32.577 27.3029 32 27.3029C31.423 27.3029 30.9508 27.775 30.9508 28.352ZM30.9508 34.647C30.9508 34.0676 31.4206 33.5979 32 33.5979C32.5794 33.5979 33.0492 34.0676 33.0492 34.647C33.0492 35.2265 32.5794 35.6962 32 35.6962C31.4206 35.6962 30.9508 35.2265 30.9508 34.647Z",
  fill: "#EF7E18"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-warning.420a86a62f58a8f87dc4791d2090f112.svg";